var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"input",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":function($event){return _vm.getImage()}}}),_vm._v(" "),_c('button',{staticClass:"btn blue",on:{"click":function($event){$event.preventDefault();return _vm.triggerInput()}}},[_vm._v("Ajouter une image")])])
}
var staticRenderFns = []

export { render, staticRenderFns }